export default __webpack_public_path__ + "static/media/Ellipse 63.7caead3d.svg";